import { IIssueSummaryResponse } from '@kcftech/prometheustypescriptapiclient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { REFRESH_INTERVAL } from 'configs/constants';
import { sdClient } from 'contexts/SDKClientContext';

export const GroupIssueMetricsDataSourceKey = 'groupIssueMetrics';

async function fetchGroupIssueMetrics(groupId: string): Promise<IIssueSummaryResponse> {
    try {
        return await sdClient.getIssueSummaryForGroup({
            groupId,
        });
    } catch (error) {
        throw new Error(
            `Failed to fetch metrics for group ${groupId}: ${
                error instanceof Error ? error.message : 'Unknown error'
            }`
        );
    }
}

export function useGroupIssueMetrics(groupId: string) {
    return useQuery({
        queryKey: [GroupIssueMetricsDataSourceKey, groupId],
        queryFn: () => fetchGroupIssueMetrics(groupId),
        refetchInterval: REFRESH_INTERVAL,
        placeholderData: keepPreviousData,
        staleTime: REFRESH_INTERVAL,
    });
}
